module.exports = __webpack_public_path__ + "static/img/img_cabinet.4c381b78.png";